// JS
import '../../custom/js/index';
import '../../custom/js/components/modal';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Component JS
import '~/src/custom/js/pagebuilder';
import '~/src/custom/js/components/pagebuilder';

// Components SCSS
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/hero/hero.scss';
import '../../custom/scss/components/search/office-search.scss';
import '../../custom/scss/components/modal/modal.scss';
import '~/src/custom/scss/pagebuilder.scss';

// import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/custom-apps/office-search';
import App from '../../custom/vue/custom-apps/containers/office-search.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#search-app');